module.exports = __webpack_public_path__ + "img/question-exchange.0a5a6b89.svg";